module.exports = __webpack_public_path__ + "img/security-item-02.3bd4de2a.svg";